import n from "react";
function o(t) {
  return t && /* @__PURE__ */ n.isValidElement(t) && t.type === n.Fragment;
}
const a = (t, e, r) => /* @__PURE__ */ n.isValidElement(t) ? /* @__PURE__ */ n.cloneElement(t, typeof r == "function" ? r(t.props || {}) : r) : e;
function u(t, e) {
  return a(t, t, e);
}
export {
  u as c,
  o as i,
  a as r
};
//# sourceMappingURL=reactNode-CwSzDQK_.mjs.map
